export default __webpack_public_path__ + "static/media/Web_instructions-03.b13379a5.png";